export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_STARTED = 'AUTH_STARTED';
export const AUTH_BIN_ENTERED = 'AUTH_BIN_ENTERED';
export const AUTH_VIDEO_IDENTIFICATION_INIT = 'AUTH_VIDEO_IDENTIFICATION_INIT';
export const AUTH_VIDEO_IDENTIFICATION_STARTED = 'AUTH_VIDEO_IDENTIFICATION_STARTED';
export const AUTH_VIDEO_IDENTIFICATION_SUCCEED = 'AUTH_VIDEO_IDENTIFICATION_SUCCEED';
export const AUTH_VIDEO_IDENTIFICATION_FAILED = 'AUTH_VIDEO_IDENTIFICATION_FAILED';
export const AUTH_VIDEO_IDENTIFICATION_RETRY = 'AUTH_VIDEO_IDENTIFICATION_RETRY';
export const AUTH_VIDEO_IDENTIFICATION_BLOCKED = 'AUTH_VIDEO_IDENTIFICATION_BLOCKED';
export const AUTH_VIDEO_QR_FORMED = 'AUTH_VIDEO_QR_FORMED';
export const AUTH_VIDEO_QR_STARTED = 'AUTH_VIDEO_QR_STARTED';
export const AUTH_SMS_CODE_REQUESTED = 'AUTH_SMS_CODE_REQUESTED';
export const AUTH_SMS_CODE_SUCCEED = 'AUTH_SMS_CODE_SUCCEED';
export const AUTH_SMS_CODE_FAILED = 'AUTH_SMS_CODE_FAILED';
export const AUTH_SMS_CODE_SEND_AGAIN = 'AUTH_SMS_CODE_SEND_AGAIN';
export const AUTH_AUTO_CONSENT = 'AUTH_AUTO_CONSENT';
export const AUTH_CONSENT_INIT = 'AUTH_CONSENT_INIT';
export const AUTH_CONSENT_AGREED = 'AUTH_CONSENT_AGREED';
export const AUTH_SUCCEED = 'AUTH_SUCCEED';
export const AUTH_SESSION_EXPIRED = 'AUTH_SESSION_EXPIRED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_REJECT = 'AUTH_REJECT';
export const ESIGN_INIT = 'ESIGN_INIT';
export const ESIGN_ISSUE_ERROR = 'ESIGN_ISSUE_ERROR';
export const ESIGN_ISSUE_STARTED = 'ESIGN_ISSUE_STARTED';
export const ESIGN_ISSUE_SUCCEED = 'ESIGN_ISSUE_SUCCEED';
export const ESIGN_SIGN_STARTED = 'ESIGN_SIGN_STARTED';
export const ESIGN_NO_SIGN = 'ESIGN_NO_SIGN';
export const ESIGN_SIGN_SUCCEED = 'ESIGN_SIGN_SUCCEED';
export const ESIGN_PIN_WRONG_PASSWORD = 'ESIGN_PIN_WRONG_PASSWORD';
export const ESIGN_SIGN_ERROR = 'ESIGN_SIGN_ERROR';
export const ESIGN_SIGN_REJECT = 'ESIGN_SIGN_REJECT';
export const ESIGN_PIN_STARTED = 'ESIGN_PIN_STARTED';
export const ESIGN_PIN_ENTERED = 'ESIGN_PIN_ENTERED';
export const ESIGN_PIN_NOT_MATCHED = 'ESIGN_PIN_NOT_MATCHED';
export const SMS_PROVIDER_TIMEOUT = 'SMS_PROVIDER_TIMEOUT';
